import Typography from "@material-ui/core/Typography"
import React from "react"
import './datablock.scss'
import DynamicHtml from "../../molecules/DynamicHtml"
import { getRandomNumber } from "../../utils/Utils";
const DataBlock = ({ title, dataItems, rowItems, onClickItem, variant = false }: any) => {
    return <div className={`${title ? "dataBlockVariant" : ""} dataBlockMain`}>
        {title && <Typography variant='inherit' className="dataBlocktitle" noWrap={false}>{title}</Typography>}
        {rowItems && <div className="rowItems">
            {rowItems.map((item: any, pageIndex: any) => {
                return <React.Fragment key={"row_" + pageIndex + getRandomNumber()}><Typography variant='inherit' color='textPrimary' className="color-grey fw-400">
                    <DynamicHtml content={item.value} />

                </Typography>
                </React.Fragment>
            })}
        </div>}

        {dataItems && <div className="dataBlock">
            <div className="dataBlocksubItm">
                {
                    dataItems && dataItems.map((subItem: any, index: number) => {
                        return (
                            <div className={`dataBlockrow ${subItem.highlight ? "hightedItem" : ""}`} key={"data_" + index + getRandomNumber()}>
                                <div className="dataBlockcol">
                                    <Typography variant='subtitle2' variantMapping={{ subtitle2: "div" }} align={"left"} noWrap={false} className="dataItemTitle color-grey fw-500">{subItem.label}</Typography>
                                    {subItem.subText &&
                                        <div onClick={subItem.hasSubContent && onClickItem ? () => onClickItem(subItem) : undefined}>
                                            <Typography variant='caption' variantMapping={{ caption: "div" }} align={"left"} noWrap={false} className={`dataItemsubTitle ${subItem.hasSubContent ? "actionableItem color-green" : "color-grey2"}`}>
                                                <DynamicHtml content={subItem.subText} />
                                            </Typography>
                                        </div>
                                    }
                                </div>
                                <div className={`dataBlockcol dataBlockcolVal color-grey fs-16 ${variant ? "w-auto" : "w-40"}`}>
                                    <Typography variant='inherit' noWrap={false} className="dataItemValCls">
                                        <DynamicHtml content={subItem.value} />
                                    </Typography>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>}

    </div>
}

export default DataBlock